// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

:root {
  /* Dark theme */
  --bg-primary: #0f0f14;
  --bg-secondary: #16161d;
  --bg-card: #1e1e28;
  --bg-card-hover: #252532;
  --text-primary: #e8e8ed;
  --text-secondary: #a1a1aa;
  --text-muted: #71717a;
  --border-color: #2d2d3a;
  --border-subtle: rgba(59, 130, 246, 0.15);
  --accent: #3b82f6;
  --accent-light: #60a5fa;
  --accent-hover: #2563eb;
  --accent-glow: rgba(59, 130, 246, 0.25);
  --success: #22c55e;
  --success-bg: rgba(34, 197, 94, 0.15);
  --error: #ef4444;
  --error-bg: rgba(239, 68, 68, 0.15);
  --warning: #eab308;
  --input-bg: #18181b;
  --input-border: #3f3f46;
  --shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  --shadow-card: 0 4px 20px rgba(0, 0, 0, 0.25);
  --shadow-accent: 0 4px 20px var(--accent-glow);
  --radius: 12px;
  --radius-sm: 8px;
  --font: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

html {
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
}

#root {
  overflow-x: hidden;
  max-width: 100vw;
}

body {
  margin: 0;
  overflow-x: hidden;
  min-height: 100vh;
  font-family: var(--font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--bg-primary);
  background-image:
    radial-gradient(ellipse 120% 80% at 50% -20%, rgba(59, 130, 246, 0.08) 0%, transparent 50%),
    radial-gradient(ellipse 80% 50% at 80% 50%, rgba(59, 130, 246, 0.04) 0%, transparent 45%);
  color: var(--text-primary);
}

/* Стилизация скроллбара для всей страницы */
body::-webkit-scrollbar,
html::-webkit-scrollbar {
  width: 8px;
}

body::-webkit-scrollbar-track,
html::-webkit-scrollbar-track {
  background: #18181b;
  border-radius: 4px;
}

body::-webkit-scrollbar-thumb,
html::-webkit-scrollbar-thumb {
  background: #3f3f46;
  border-radius: 4px;
  -webkit-transition: background 0.2s;
  transition: background 0.2s;
}

body::-webkit-scrollbar-thumb:hover,
html::-webkit-scrollbar-thumb:hover {
  background: #3b82f6;
}

html {
  scrollbar-width: thin;
  scrollbar-color: #3f3f46 #18181b;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;EACzC,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,6CAA6C;EAC7C,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B;;6FAE2F;EAC3F,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,mCAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE;aACW;AACb","sourcesContent":["*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n:root {\r\n  /* Dark theme */\r\n  --bg-primary: #0f0f14;\r\n  --bg-secondary: #16161d;\r\n  --bg-card: #1e1e28;\r\n  --bg-card-hover: #252532;\r\n  --text-primary: #e8e8ed;\r\n  --text-secondary: #a1a1aa;\r\n  --text-muted: #71717a;\r\n  --border-color: #2d2d3a;\r\n  --border-subtle: rgba(59, 130, 246, 0.15);\r\n  --accent: #3b82f6;\r\n  --accent-light: #60a5fa;\r\n  --accent-hover: #2563eb;\r\n  --accent-glow: rgba(59, 130, 246, 0.25);\r\n  --success: #22c55e;\r\n  --success-bg: rgba(34, 197, 94, 0.15);\r\n  --error: #ef4444;\r\n  --error-bg: rgba(239, 68, 68, 0.15);\r\n  --warning: #eab308;\r\n  --input-bg: #18181b;\r\n  --input-border: #3f3f46;\r\n  --shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\r\n  --shadow-card: 0 4px 20px rgba(0, 0, 0, 0.25);\r\n  --shadow-accent: 0 4px 20px var(--accent-glow);\r\n  --radius: 12px;\r\n  --radius-sm: 8px;\r\n  --font: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n}\r\n\r\nhtml {\r\n  overflow-x: hidden;\r\n  -webkit-text-size-adjust: 100%;\r\n}\r\n\r\n#root {\r\n  overflow-x: hidden;\r\n  max-width: 100vw;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  overflow-x: hidden;\r\n  min-height: 100vh;\r\n  font-family: var(--font);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background: var(--bg-primary);\r\n  background-image:\r\n    radial-gradient(ellipse 120% 80% at 50% -20%, rgba(59, 130, 246, 0.08) 0%, transparent 50%),\r\n    radial-gradient(ellipse 80% 50% at 80% 50%, rgba(59, 130, 246, 0.04) 0%, transparent 45%);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Стилизация скроллбара для всей страницы */\r\nbody::-webkit-scrollbar,\r\nhtml::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\nbody::-webkit-scrollbar-track,\r\nhtml::-webkit-scrollbar-track {\r\n  background: #18181b;\r\n  border-radius: 4px;\r\n}\r\n\r\nbody::-webkit-scrollbar-thumb,\r\nhtml::-webkit-scrollbar-thumb {\r\n  background: #3f3f46;\r\n  border-radius: 4px;\r\n  transition: background 0.2s;\r\n}\r\n\r\nbody::-webkit-scrollbar-thumb:hover,\r\nhtml::-webkit-scrollbar-thumb:hover {\r\n  background: #3b82f6;\r\n}\r\n\r\nhtml {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #3f3f46 #18181b;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
